import React from 'react';
import Header from '../../components/shared/Layouts/header/header';
import Sidebar from '../../components/shared/Layouts/sidebar/sidebar';

import './fullview.scss';
import { Box, Stack } from '@mui/material';
import CollapsibleSidebar from '../../components/shared/Layouts/sidebar/CollapsibleSidebar';
import { ChevronRight } from '@mui/icons-material';
import { METADATA_KEY } from '../../utils/utils';
import { connect } from 'react-redux';


const containerStyle = {
  display: 'grid',
  gridTemplateColumns: '200px auto',
  minHeight: '100vh',
  width: '100%',
  height: '100%',
  zoom: '80%'
};

const Style1 = {
  height: '100%',
  padding: 0,
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
  flexGrow: 1
};

class FullView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      localDrawerState: false
    };
    this.sidebarRef = React.createRef();
  }

  clickOutside(e) {
    document.getElementById('header').click();
  }
  componentDidMount() {
    const drawerState = window.localStorage.getItem('drawerState');
    this.setState({
      open: JSON.parse(drawerState),
      localDrawerState: JSON.parse(drawerState)
    });
  }

  handleToggleDrawer = () => {
    this.setState((prevState) => {
      window.localStorage.setItem(
        'drawerState',
        JSON.stringify(!prevState.open)
      );
      return {
        open: !prevState.open,
        localDrawerState: !prevState.open
      };
    });
  };

  handleMouseEnter = () => {
    this.setState({ open: true });
  };

  handleMouseLeave = () => {
    if (!this.state.localDrawerState) {
      this.setState({ open: false });
    }
  };
  render() {
    const { open } = this.state;
    const sidebarWidth = open ? '300px' : '80px';

    return (
      <>
        <div
          className='App'
          style={Style1}
        >
          <div
            className='container-fluid'
            style={Style1}
          >
            <Stack
              sx={{ position: 'relative' }}
              direction={'row'}
              className='page-container'
            >
              <div
                style={{ position: 'relative' }}
                ref={this.sidebarRef}
              >
                <CollapsibleSidebar
                  open={open}
                  onMouseEnter={this.handleMouseEnter}
                  mouseLeave={this.handleMouseLeave}
                />
              </div>
              <div
                className='col content'
                style={{
                  marginLeft: sidebarWidth,
                  transition: 'margin-left 0.3s ease-in-out'
                }}
              >
                <Box
                  style={{
                    left: sidebarWidth
                  }}
                  className='sidebar-expand-btn'
                  onClick={this.handleToggleDrawer}
                >
                  <ChevronRight
                    style={{
                      fontSize: '30px',
                      transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'all 0.3s ease-in-out',
                      color: '#c3c7dc'
                    }}
                  />
                </Box>
                {this.props.showTooltip && (
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      padding: '4px 8px',
                      backgroundColor: '#000',
                      color: '#fff',
                      borderRadius: '6px',
                      fontSize: '14px',
                      whiteSpace: 'nowrap',
                      pointerEvents: 'none',
                      zIndex: 9999,
                      transform: `translate(${this.props.tooltipCoords.x / 0.8}px, ${this.props.tooltipCoords.y / 0.8 - 45}px)`,
                    }}
                  >
                    {this.props.tooltipText}
                  </div>
                )}
                <Header />
                {this.props.children}
              </div>
            </Stack>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  showTooltip: state.common.showTooltip,
  tooltipText: state.common.tooltipText,
  tooltipCoords: state.common.tooltipCoords,
});

export default connect(mapStateToProps)(FullView);
